import { getDefaultOptions } from "../../lib/getDefaultValues";

const qrOptions = (action, state) => {
    const { type, options } = action;
    switch (type) {
        case 'unlink':
        case 'edit':
            return options;
        case 'liquid':
        case 'reset':
            return getDefaultOptions(options?.randKey || '');
        case 'shape':
            return {
                ...state,
                shape: options,
            };
        case 'eye':
            const cornerEyeOptions = {
                ...state.cornersDotOptions,
                ...options
            };
            return { ...state, cornersDotOptions: cornerEyeOptions };
        case 'frame':
            const cornerFrameOptions = {
                ...state.cornersSquareOptions,
                ...options
            };
            return { ...state, cornersSquareOptions: cornerFrameOptions };
        case 'background':
            const backgroundOptions = {
                ...state.backgroundOptions,
                ...options
            };
            return { ...state, backgroundOptions: backgroundOptions };
        case 'dots':
            const dotsOptions = {
                ...state.dotsOptions,
                ...options
            };
            return { ...state, dotsOptions: dotsOptions };
        case 'logo':
            return {
                ...state, 
                image: options,
                qrOptions: {
                    ...state.qrOptions,
                    errorCorrectionLevel: 'H'
                }
            };
        case 'remove-logo':
            return {
                ...state, 
                image: null,
                qrOptions: {
                    ...state?.qrOptions,
                    errorCorrectionLevel: 'M'
                }
            };
        case 'redirect':
            return { ...state, data: options };
        case 'randkey':
            return { ...state, data: `https://lqr.ai/${options.randKey}` };
        case 'resize':
            return { ...state, height: options, width: options }
        default:
            return action;
    };
};

export default qrOptions;
